import { render, staticRenderFns } from "./DashboardGestor.vue?vue&type=template&id=d5dcc7a2"
import script from "./DashboardGestor.vue?vue&type=script&lang=js"
export * from "./DashboardGestor.vue?vue&type=script&lang=js"
import style0 from "./DashboardGestor.vue?vue&type=style&index=0&id=d5dcc7a2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VProgressCircular,VRow})
